{
  "Financial Instruments": "Financial Instruments",
  "Payments & Cash Management": "Payments & Cash Management",
  "Securities & Custody Services": "Securities & Custody Services",
  "Trade & Receivables Finance": "Trade & Receivables Finance",
  "Corporate Analysis & Credits": "Corporate Analysis & Credits",
  "Financing & Loans": "Financing & Loans",
  "Pensions & Insurances": "Pensions & Insurances",
  "Risk & Profitability": "Risk & Profitability",
  "Savings & Investments": "Savings & Investments",
  "Software Development": "Software Development",
  "Quality Assurance": "Quality Assurance",
  "Automation": "Automation",
  "Blockchain": "Blockchain",
  "Social Networks": "Social Networks",
  "Web Development": "Web Development",
  "Mobile Development": "Mobile Development",
  "Robotics": "Robotics",
  "DevOps": "DevOps",
  "IOT": "IOT",
  "Languages": "Languages",
  "Team Management & Development": "Team Management & Development",
  "Strategic": "Strategic",
  "Organizational Leadership": "Organizational Leadership",
  "Executive Leadership": "Executive Leadership",
  "Project Management": "Project Management",
  "Coaching & Mentoring": "Coaching & Mentoring",
  "People Management": "People Management",
  "Personal Leadership": "Personal Leadership",
  "Negotiation": "Negotiation",
  "Conflict Resolution": "Conflict Resolution",
  "Directives": "Directives",
  "Interpersonal Skills": "Interpersonal Skills",
  "Collaboration": "Collaboration",
  "Self Development": "Self Development",
  "Career Development": "Career Development",
  "Time Management": "Time Management",
  "Wellness": "Wellness",
  "Resilience": "Resilience",
  "Feedback": "Feedback",
  "Agile": "Agile",
  "Service Design": "Service Design",
  "Business Strategy": "Business Strategy",
  "Business Analytics": "Business Analytics",
  "Change Management": "Change Management",
  "Digital Literacy": "Digital Literacy",
  "Growth & Acquisitions": "Growth & Acquisitions",
  "Lean Concept": "Lean Concept",
  "Legal": "Legal",
  "Organizational Development": "Organizational Development",
  "Financial Fundamentals": "Financial Fundamentals",
  "Global Mandatory Training": "Global Mandatory Training",
  "License Compliance": "License Compliance",
  "Regulatory": "Regulatory",
  "Our Brand": "Our Brand",
  "Our Health & Work Environment": "Our Health & Work Environment",
  "Our Sustainability": "Our Sustainability",
  "Our Vision & Values": "Our Vision & Values",
  "Our Compensation & Benefits": "Our Compensation & Benefits",
  "Our Diversity & Inclusion": "Our Diversity & Inclusion",
  "Get Started": "Get Started",
  "Service & Sales Methodologies": "Service & Sales Methodologies",
  "Strategy": "Strategy",
  "Customer Service": "Customer Service",
  "Advisory": "Advisory",
  "Service & Sales Research": "Service & Sales Research",
  "Service & Sales Planning": "Service & Sales Planning",
  "Opportunity Management": "Opportunity Management",
  "Portfolio Management": "Portfolio Management",
  "Relationship Management": "Relationship Management",
  "Customer Success": "Customer Success",
  "Cyber Security": "Cyber Security",
  "IT Security": "IT Security",
  "Physical Security": "Physical Security",
  "Risk Management": "Risk Management",
  "Operational Risk": "Operational Risk",
  "Security Certifications": "Security Certifications",
  "Security Audits": "Security Audits",
  "Security Testing": "Security Testing",
  "Security Processes": "Security Processes",
  "Compliance": "Compliance",
  "Risk Assessment": "Risk Assessment",
  "Machine Learning/AI": "Machine Learning/AI",
  "Data Structures & Algorithms": "Data Structures & Algorithms",
  "Data Analysis": "Data Analysis",
  "Data Science": "Data Science",
  "Data Governance": "Data Governance",
  "Data Modelling": "Data Modelling",
  "Data Visualisation & Dashboards": "Data Visualisation & Dashboards",
  "Predictive Analytics": "Predictive Analytics",
  "Big Data": "Big Data",
  "Processes": "Processes",
  "Process & Automation": "Process & Automation",
  "Service Centres": "Service Centres",
  "Logistics": "Logistics",
  "Administration": "Administration",
  "Corporate Sustainability": "Corporate Sustainability",
  "Human Sustainability": "Human Sustainability",
  "Social Sustainability": "Social Sustainability",
  "Economic Sustainability": "Economic Sustainability",
  "Environmental Sustainability": "Environmental Sustainability",
  "Development Sustainability": "Development Sustainability",
  "Economics": "Economics",
  "Investments": "Investments",
  "Tax": "Tax",
  "Securities": "Securities",
  "International": "International",
  "Insurance": "Insurance",
  "Payment Processing": "Payment Processing",
  "Continuous Learning": "Continuous Learning",
  "Human Resources Management": "Human Resources Management",
  "Diversity & Inclusion": "Diversity & Inclusion",
  "Employee Onboarding": "Employee Onboarding",
  "Rights & Regulations": "Rights & Regulations",
  "People & Culture Strategy": "People & Culture Strategy",
  "Marketing Strategy": "Marketing Strategy",
  "Marketing Analytics": "Marketing Analytics",
  "Communication": "Communication",
  "Communication Strategy": "Communication Strategy",
  "Branding": "Branding",
  "Functional Skills": "Functional Skills",
  "Tools & Technologies": "Tools & Technologies",
  "E-Safety": "E-Safety",
  "Connecting & Collaborating": "Connecting & Collaborating",
  "Content Creation": "Content Creation",
  "Communication and Netiquette": "Communication and Netiquette",
  "Cloud": "Cloud",
  "Networking": "Networking",
  "Operating Systems": "Operating Systems",
  "Support & Operations": "Support & Operations",
  "Database Administration": "Database Administration",
  "Server Management": "Server Management",
  "Digital Design": "Digital Design",
  "User Experience Design": "User Experience Design",
  "Graphic Design": "Graphic Design",
  "Industrial Design": "Industrial Design",
  "Design Methodology": "Design Methodology",
  "Audio Design": "Audio Design",
  "Medical Engineering": "Medical Engineering",
  "Biological Engineering": "Biological Engineering",
  "Chemical Engineering": "Chemical Engineering",
  "Electrical Engineering": "Electrical Engineering",
  "Mechanical Engineering": "Mechanical Engineering",
  "Physics": "Physics",
  "Astronomy": "Astronomy",
  "Environmental Engineering": "Environmental Engineering",
  "Research Methodologies": "Research Methodologies"
}
